const shared={
    check:'Events',
    title:'Event',
    url:'event',
    addApi:'api/event/create',
    editApi:'api/event/edit',
    detailApi:'api/event/details',
    listApi:'api/event/all',
    statusApi:'api/event/edit',
    groupApi:"api/group/list",
    deleteApi:'api/event/delete'
}

export default shared